import React, { Component } from "react";
import { connect } from "react-redux";
import Formsy from "formsy-react";
import translator from "../../../components/localization/translator";
import { Modal } from "react-bootstrap";
import areaConf from "../../../config/area";
import TextareaWithLabel from "../../../components/common/elements/TextareaWithLabel";
import FooterButtons from "../../../components/common/elements/FooterButtons";
import FormInput from "../../../components/common/elements/FormInput";
import { closeAreaModal, createAreaByAPI, updateAreaByAPI } from "../area.action";

class AreaDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            areaData: {},
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.areaDetails && nextProps.areaDetails.selectedArea !== undefined) {
            this.state.areaData = nextProps.areaDetails.selectedArea;
        }
    }

    save() {
        const id = this.state.areaData._id;
        if (id) {
            const data = { ...this.state.areaData };
            delete data._id;
            this.update(id, data, () => {
                this.cancel();
            });
        } else {
            this.create(this.state.areaData, () => {
                this.cancel();
            });
        }
    }

    create = (data, cb) => {
        this.props.createAreaByAPI(data, cb);
    };

    update = (id, data, cb) => {
        this.props.updateAreaByAPI(id, data, cb);
    };

    cancel = () => {
        this.props.closeAreaModal();
        this.setState({ areaData: {}, isDisabled: true });
    };

    renderFooter() {
        return (
            <Modal.Footer>
                <FooterButtons
                    cancelButton={translator.translate("_cancel_")}
                    saveButton={translator.translate("_save_")}
                    save={this.save.bind(this)}
                    cancel={this.cancel}
                    isDisabled={this.state.isDisabled}
                />
            </Modal.Footer>
        );
    }


    disableButton = () => {
        this.setState({ isDisabled: true });
    };

    enableButton = () => {
        this.setState({ isDisabled: false });
    };

    getTitle() {
        const selectedArea = this.props.areaDetails.selectedArea || {};
        return <b>{selectedArea._id ? translator.translate("_update_area_") : translator.translate("_create_new_area_")}</b>;
    }

    renderAreaCoordinates(field, id) {
        return (
            <TextareaWithLabel
                key={id}
                label={field.title}
                id={id}
                htmlFor={id}
                name={field.key}
                value={this.state.areaData[field.key]}
                onChange={(e) => {
                    this.setState({
                        areaData: {
                            ...this.state.areaData,
                            [field.key]: e.target.value,
                        },
                    });
                }}
            >
            </TextareaWithLabel>
        );
    }

    renderInput(field, id) {
        const change = field.canChange;
        if (!change) {
            return null;
        }
        if (change.type === "area_coordinate") {
            return this.renderAreaCoordinates(field, id);
        }
        const key = field.key;
        return (
            <FormInput
                key={id}
                htmlFor={id}
                label={field.title}
                type={change.type}
                id={key}
                name={key}
                value={this.state.areaData[key]}
                onChange={(e) => {
                    this.setState({
                        areaData: {
                            ...this.state.areaData,
                            [key]: e.target.value,
                        },
                    });
                }}
                validations={change.validations}
                validationErrors={change.validationErrors}
                required={field.isRequired === false ? false : true} />
        );
    }

    render() {
        return (
            <Modal
                bsSize="large"
                show={this.props.areaDetails.showModal}
                onHide={this.cancel}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {this.getTitle()}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="scrollable modal-possition">
                    <Formsy onValid={this.enableButton} onInvalid={this.disableButton}>
                        <div>
                            {areaConf.getColumns().map(this.renderInput.bind(this))}
                        </div>
                    </Formsy>
                </Modal.Body>
                {this.renderFooter()}
            </Modal>
        );
    }
}

let mapStateToProps = (state) => {
    return {
        areaDetails: state.areaDetails,
    };
};
export default connect(mapStateToProps, {
    createAreaByAPI,
    updateAreaByAPI,
    closeAreaModal,
})(AreaDetails);
